import { render, staticRenderFns } from "./ExistingWillChangesEstateYN.vue?vue&type=template&id=70d6593e"
import script from "./ExistingWillChangesEstateYN.vue?vue&type=script&lang=js"
export * from "./ExistingWillChangesEstateYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports